import React, {Component, PureComponent} from "react";
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner';
import {Config, Server, helper} from "./../app.js";

export default class ProductInfo extends PureComponent 
{
    productPicFolder = Config.instance.get('products_pic_folder');

    constructor (props)
    {
        super(props);

        this.state = {
            info: null
        };
    }
    loadProductInfo ()
    {
        //console.log('ProductInfo.loadProductInfo()', this.props.product);
        if (!helper.isNotObjectOrEmpty(this.props.product))
        {
            const {txt_file: textFile} = this.props.product;        

            if (textFile)
            {
                Server.instance
                    .query('get_product_info', 
                        {
                            info_file: textFile
                        })
                    .then(info => this.setState({info}))
                    .catch(() => this.setState({info: {}}));
            }
            else
                this.setState({info: {}})
        }
    }
    componentDidMount () 
    {
        this.loadProductInfo();
    }
    render () 
    {
        const info = this.state.info,
            product = this.props.product;
        let title = '',
            picFile = null,
            picture = '',
            description = '',
            properties = '',
            moreDescription = '';

        if (!helper.isNotObjectOrEmpty(product))
        {
            ({
                name: title = 'Наименование выбранной позиции',
                pic_file: picFile
            } = product);

            //console.log('ProductInfo.render()', info, product, picFile);

            /* @todo `${this.productPicFolder}${picFile}.jpg`
            // проверка существования 

            picImg = new Image()
            picImg.src = '';
            picImg.onload = function () 
            {
                инфо уже ставим а картинку после прелоадера
            }
            */

            if (!helper.isNotObjectOrEmpty(info))
            //if (info)
            {            
                picture = picFile
                            ? <div className="picBox bg-dark rounded-top">
                                    <Card.Img variant="top" src={`${this.productPicFolder}${picFile}.jpg`} />
                                </div>
                            : <div className="w-100 py-5 bg-dark text-center text-light rounded-top"><div className="my-5 py-3">Нет фото</div></div>;            
                
                //if (!helper.isNotObjectOrEmpty(info)) {
                    ({
                        desc: description = '<p>Выберите позицию из списка для отображения фото и описания</p>',
                        props: properties,
                        more: moreDescription
                    } = info);
                //}
            }
            else if (picFile)
            {
                picture = <div className="picBox bg-dark rounded-top">
                            <Card.Img variant="top" src={`${this.productPicFolder}${picFile}.jpg`} />
                        </div>;
            }
            else
                picture = <div className="picBox py-5 bg-dark text-light rounded-top"><div className="my-5 py-3">                            
                            <Spinner animation="border" variant="light" role="status">
                                <span className="sr-only">Загрузка данных...</span>
                            </Spinner>
                        </div></div>;
        } 
        else
        {
            title = 'Наименование выбранной позиции';
            picture = <div className="w-100 py-5 bg-dark text-center text-light rounded-top"><div className="my-5 py-3">Фото выбранной позиции</div></div>;            
            description = '<p>Выберите позицию в списке наименований для отображения фото и описания</p>';
        }

        return (
            <Card className="product_info">                
                {picture}
                <Card.Body>
                    <Card.Title>{title}</Card.Title>
                    {description || moreDescription
                        ? <Card.Text as="div">
                            {description 
                                ? <div dangerouslySetInnerHTML={{__html: description}} /> 
                                : <div dangerouslySetInnerHTML={{__html: moreDescription}} />
                            }
                            {properties
                                ? <div dangerouslySetInnerHTML={{__html: properties}} />
                                : ''
                            }
                            {description && moreDescription
                                ? <Accordion>
                                    <Accordion.Toggle className="txt_interactive" as="span" eventKey="0">подробнее</Accordion.Toggle>
                                    <Accordion.Collapse className="pt-2" eventKey="0">
                                        <div dangerouslySetInnerHTML={{__html: moreDescription}} />
                                    </Accordion.Collapse>
                                </Accordion>
                                : ''}
                        </Card.Text>
                        : ''}
                </Card.Body>                
            </Card>
        );
    }
}
/*
    componentWillReceiveProps (newProps)
    {
        //console.log('ProductInfo.componentWillReceiveProps', newProps.product, this.props.product);
        if (
            (helper.isNotObjectOrEmpty(newProps.product) && !helper.isNotObjectOrEmpty(this.props.product))
            ||
            (!helper.isNotObjectOrEmpty(newProps.product) && helper.isNotObjectOrEmpty(this.props.product))
            ||
            newProps.product.id != this.props.product.id
        )
        {
            //console.log("ProductInfo.componentWillReceiveProps: call loadProductInfo()");
            // @todo вероятно будут новые пропсы но останется старый state.info
            this.loadProductInfo();
        }
    }*/